import Vue from 'vue';

import antd from './antd';
import router from './router';
import store from './store';
import App from './App.vue';
import * as utils from './utils/common';
import '@/assets/global.scss';

Vue.use(antd);

Vue.config.productionTip = false;

Vue.prototype.$noop = utils.noop;
Vue.prototype.$promisify = utils.promisify;
Vue.prototype.$catch = utils.catchError;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
